<template>
    <!-- z-50 so the flyout paints above page content that uses z-10 (e.g. the active date segment on Documents) -->
    <div id="vault-list" class="md:relative md:z-50 inset-y-0 left-0 hide" v-if="!static">
        <transition name="slideLeft">
            <div class="w-64 h-full bg-grey-darkest border-r border-grey-dark shadow-lg flex flex-col z-50 fixed" v-if="toggleVaults">
                <button class="md:hidden text-white self-start px-4 pt-4" @click.prevent="toggleVault(false)">
                    <i class="fa fa-chevron-left"></i> Back
                </button>

                <div class="px-4 pt-6 pb-3 flex items-center justify-between">
                    <p class="text-white font-medium">Switch vault</p>
                    <span class="px-2 py-px rounded-full text-xs font-semibold bg-brand text-white">{{ vaults.length }}</span>
                </div>

                <div class="px-4 relative">
                    <i class="fa fa-search absolute text-grey" style="left: 1.75rem; top: 0.8rem"></i>
                    <input
                        type="text"
                        v-model="search.vault"
                        class="h-10 w-full rounded border border-grey-dark bg-white text-black text-sm pl-8 pr-3"
                        placeholder="Search vaults"
                        @input="searchVault"
                    >
                </div>

                <div class="mt-3 flex-1 overflow-y-auto pb-4">
                    <a
                        v-for="vault in all_vaults"
                        :key="vault.id"
                        href="#"
                        class="block px-4 py-2 text-sm no-underline break-words border-l-4 hover:bg-black"
                        :class="vault.id == currentVaultId ? 'bg-black text-brand font-medium border-brand' : 'text-white border-transparent'"
                        @click.prevent="toggleVault(false); selectAsCurrentVault(vault.id)"
                    >
                        {{ vault.name }}
                    </a>
                    <p class="px-4 py-2 text-sm text-grey" v-if="all_vaults.length == 0">No vaults match.</p>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
  props: ["vaults", "static", "toggle-vaults"],

  data() {
    return {
      search: {
        vault: ""
      },

      all_vaults: []
    };
  },

  mounted() {
    this.all_vaults = _.cloneDeep(this.vaults);
  },

  methods: {
    selectAsCurrentVault(vault_id) {
      this.$emit("select-as-current-vault", vault_id);
    },

    toggleVault(bool) {
      this.$emit("toggle-vaults", bool);
    },

    searchVault() {
      this.all_vaults = this.vaults.filter(vault => {
        return _.includes(
          vault.name.toLowerCase(),
          this.search.vault.toLowerCase()
        );
      });
    }
  },

  computed: {
    currentVaultId() {
      const current = this.$store.getters.getCurrentVault;
      return current ? current.id : null;
    },
  },

  watch: {
    vaults() {
      this.all_vaults = _.cloneDeep(this.vaults);
    }
  }
};
</script>

<style>
</style>
